{
  "agent-sessions-discovery.example.current-view.ai-non-final": [
    {
      "type": 0,
      "value": "Current simulated view: "
    },
    {
      "type": 1,
      "value": "view"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "agent-sessions-discovery.example.events.ai-non-final": [
    {
      "type": 0,
      "value": "Pulses shown: "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "agent-sessions-discovery.example.navigate.ai-non-final": [
    {
      "options": {
        "backlog": {
          "value": [
            {
              "type": 0,
              "value": "Backlog"
            }
          ]
        },
        "board": {
          "value": [
            {
              "type": 0,
              "value": "Board"
            }
          ]
        },
        "list": {
          "value": [
            {
              "type": 0,
              "value": "List"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "View"
            }
          ]
        },
        "timeline": {
          "value": [
            {
              "type": 0,
              "value": "Timeline"
            }
          ]
        }
      },
      "type": 5,
      "value": "view"
    }
  ],
  "agent-sessions-discovery.example.setting.ai-non-final": [
    {
      "type": 0,
      "value": "Agent Sessions"
    }
  ],
  "agent-sessions-discovery.example.settings.ai-non-final": [
    {
      "type": 0,
      "value": "View settings"
    }
  ],
  "agent-sessions-discovery.settings-new.ai-non-final": [
    {
      "type": 0,
      "value": "New"
    }
  ],
  "agent-sessions-pulse-poc.reopen.ai-non-final": [
    {
      "type": 0,
      "value": "Reopen announcement"
    }
  ],
  "agent-sessions-pulse-poc.view-settings.ai-non-final": [
    {
      "type": 0,
      "value": "View settings"
    }
  ],
  "agent-visibility-changeboarding.acknowledge": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "agent-visibility-changeboarding.available-board-backlog-ready": [
    {
      "options": {
        "board": {
          "value": [
            {
              "type": 0,
              "value": "We’ve taken care of Board for you:"
            }
          ]
        },
        "both": {
          "value": [
            {
              "type": 0,
              "value": "We’ve taken care of Board and Backlog for you:"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "We’ve taken care of Backlog for you:"
            }
          ]
        }
      },
      "type": 5,
      "value": "availableViews"
    }
  ],
  "agent-visibility-changeboarding.available-manual-setting": [
    {
      "options": {
        "both": {
          "value": [
            {
              "type": 0,
              "value": "Select view settings in List and Timeline to add agents:"
            }
          ]
        },
        "list": {
          "value": [
            {
              "type": 0,
              "value": "Select view settings in List to add agents:"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Select view settings in Timeline to add agents:"
            }
          ]
        }
      },
      "type": 5,
      "value": "availableViews"
    }
  ],
  "agent-visibility-changeboarding.backlog": [
    {
      "type": 0,
      "value": "Backlog"
    }
  ],
  "agent-visibility-changeboarding.board": [
    {
      "type": 0,
      "value": "Board"
    }
  ],
  "agent-visibility-changeboarding.list": [
    {
      "type": 0,
      "value": "List"
    }
  ],
  "agent-visibility-changeboarding.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "agent-visibility-changeboarding.open-view-tooltip": [
    {
      "type": 0,
      "value": "Open "
    },
    {
      "type": 1,
      "value": "view"
    }
  ],
  "agent-visibility-changeboarding.opens-in-new-tab": [
    {
      "type": 0,
      "value": "opens in a new tab"
    }
  ],
  "agent-visibility-changeboarding.pause-previews": [
    {
      "type": 0,
      "value": "Pause previews"
    }
  ],
  "agent-visibility-changeboarding.play-previews": [
    {
      "type": 0,
      "value": "Play previews"
    }
  ],
  "agent-visibility-changeboarding.previous": [
    {
      "type": 0,
      "value": "Previous"
    }
  ],
  "agent-visibility-changeboarding.timeline": [
    {
      "type": 0,
      "value": "Timeline"
    }
  ],
  "agent-visibility-changeboarding.welcome-body": [
    {
      "type": 0,
      "value": "Start and follow agent work in context at the scale you need, from a single card or column to multiple work items at once. Additionally, you can "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "group"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "filter"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " by agents."
    }
  ],
  "agent-visibility-changeboarding.welcome-title": [
    {
      "type": 0,
      "value": "Welcoming agentic teammates"
    }
  ],
  "agent-visibility-changeboarding.welcome-views": [
    {
      "type": 0,
      "value": "Agents are now available in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Board, Backlog, List"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Timeline."
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Saved views are now in timeline view.\n\nSave your view for everyone in the project or reset it back to your previous saved view."
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "Save and reset your timeline view"
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.primary-action": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.secondary-action": [
    {
      "type": 0,
      "value": "More about saved views"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\n\nYou can make changes to your view or reset to the admin's view anytime."
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "Reset your view"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.primary-action": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.secondary-action": [
    {
      "type": 0,
      "value": "More about saved views"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsBody": [
    {
      "type": 0,
      "value": "Add the fields you need and remove the fields you don’t."
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsHeadline": [
    {
      "type": 0,
      "value": "Add and remove fields"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.backButton": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeBody": [
    {
      "type": 0,
      "value": "More fields and more ways to surface the information that is important to you."
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeHeadline": [
    {
      "type": 0,
      "value": "A new home for filters"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsBody": [
    {
      "type": 0,
      "value": "Reorder and pin fields to prioritize what matters most to you."
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsHeadline": [
    {
      "type": 0,
      "value": "Reorder and pin fields"
    }
  ],
  "jira-filter-refinement-standalone-release-changeboarding.tour.stepIndicator": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "jira-software-backlog-bulk-agents-changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Select the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Agent sessions"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " field to monitor agent activity."
    }
  ],
  "jira-software-backlog-bulk-agents-changeboarding.spotlight.configureFields": [
    {
      "type": 0,
      "value": "Configure fields"
    }
  ],
  "jira-software-backlog-bulk-agents-changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "View & manage agent activity"
    }
  ],
  "jira-software-list-bulk-agent-changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Select the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Agent sessions"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " column to monitor agent activity."
    }
  ],
  "jira-software-list-bulk-agent-changeboarding.spotlight.configureColumns": [
    {
      "type": 0,
      "value": "Configure columns"
    }
  ],
  "jira-software-list-bulk-agent-changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "View & manage agent activity"
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.step1.description": [
    {
      "type": 0,
      "value": "Select the highest level of work you want to see. Zoom out for a high-level overview or drill down into the details."
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.step1.title": [
    {
      "type": 0,
      "value": "Set your timeline level "
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.step2.description": [
    {
      "type": 0,
      "value": "Hide items that aren't linked to a higher level parent to keep your timeline clean and focused on your primary goals."
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.step2.title": [
    {
      "type": 0,
      "value": "Focus on what matters"
    }
  ],
  "jira-software-timeline-hierarchy-changeboarding-flag.stepCount": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.description": [
    {
      "type": 0,
      "value": "Use view settings to control exactly how your timeline looks and feels."
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.title": [
    {
      "type": 0,
      "value": "Your timeline, your way"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.description": [
    {
      "type": 0,
      "value": "Decide how hierarchy appears when filters are applied."
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.title": [
    {
      "type": 0,
      "value": "Control your hierarchy"
    }
  ],
  "jira-software-timeline-inline-hierarchy-changeboarding-flag.stepCount": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "jira-software-timeline-m3.descriptionContentBulkOperations": [
    {
      "type": 0,
      "value": "Edit, move, transition, watch or delete multiple work items simultaneously."
    }
  ],
  "jira-software-timeline-m3.descriptionContentCustomizeBar": [
    {
      "type": 0,
      "value": "Make specific work items easier to scan or highlight as a priority."
    }
  ],
  "jira-software-timeline-m3.descriptionContentFindWork": [
    {
      "type": 0,
      "value": "Search, filter and group work items."
    }
  ],
  "jira-software-timeline-m3.descriptionContentSeeSubtasks": [
    {
      "type": 0,
      "value": "They now appear under epics."
    }
  ],
  "jira-software-timeline-m3.headingContentBulkOperations": [
    {
      "type": 0,
      "value": "Reduce repetitive work"
    }
  ],
  "jira-software-timeline-m3.headingContentCustomizeBar": [
    {
      "type": 0,
      "value": "Customize bars using colors"
    }
  ],
  "jira-software-timeline-m3.headingContentFindWork": [
    {
      "type": 0,
      "value": "Quickly find work items"
    }
  ],
  "jira-software-timeline-m3.headingContentSeeSubtasks": [
    {
      "type": 0,
      "value": "See subtasks at a glance"
    }
  ],
  "jira-software-timeline-m3.modal.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-software-timeline-m3.modal.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-software-timeline-m3.modal.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-software-timeline-m3.timelineImprovmentsLink": [
    {
      "type": 0,
      "value": "Read about Timeline improvements."
    }
  ],
  "jira-yurree.jira-agent-sessions-awareness.description": [
    {
      "type": 0,
      "value": "Find Agent Sessions in the view settings for your board, backlog, list, or timeline. Available views depend on your space."
    }
  ],
  "jira-yurree.jira-agent-sessions-awareness.title": [
    {
      "type": 0,
      "value": "New ways to use agents in Jira"
    }
  ],
  "jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "post-office.software-timeline-testing.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.software-timeline-testing.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.software-timeline-testing.test-message.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-10k-issues-flag.actions": [
    {
      "type": 0,
      "value": "Learn more about the 10k limit"
    }
  ],
  "timeline-10k-issues-flag.description": [
    {
      "type": 0,
      "value": "Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."
    }
  ],
  "timeline-10k-issues-flag.title": [
    {
      "type": 0,
      "value": "This space has more than 10k work items."
    }
  ],
  "timeline-feedback-collector.spotlight.body": [
    {
      "type": 0,
      "value": "In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don’t want."
    }
  ],
  "timeline-feedback-collector.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-feedback-collector.spotlight.give-feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "timeline-feedback-collector.spotlight.heading": [
    {
      "type": 0,
      "value": "We’re updating Jira timelines"
    }
  ]
}